import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../Component/Common/Table";
import CreateOrgDepartments from "../../Component/dialogue/CreateOrgDepartments";
import Button from "../../Component/Common/Button";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import { handleEdit, handleOpenNew } from "../../util/Dialogue";
import {
  deleteOrgDepartment,
  getOrgDepartments,
} from "../../store/organizationUser/organizationUser.action";
import { warning } from "../../util/Alert";
import PageContainer from "../../Component/Common/Page";

const OrgDepartments = () => {
  const dispatch = useDispatch();
  const { departments } = useSelector((state) => state.organizationUser);

  useEffect(() => {
    dispatch(getOrgDepartments());
  }, [dispatch]);

  const handleDeleteDepartment = (deptId) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            dispatch(deleteOrgDepartment(deptId));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const deptMapData = [
    {
      Header: "Name",
      Cell: ({ row }) => <p className="fw-bold mb-0">{row?.name}</p>,
    },
    {
      Header: "Employee Count",
      Cell: ({ row }) => <p className="mb-0">{row?.employeeCount}</p>,
    },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center gap-2">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(dispatch, "createOrgDepartments", row)}
          />
          <Button
            className="icon-btn"
            startIcon={<TrashIcon />}
            onClick={() => handleDeleteDepartment(row._id)}
          />
        </div>
      ),
    },
  ];

  return (
    <PageContainer>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Organization Departments</h3>
        <div className="new-fake-btn pe-lg-4">
          <Button
            startIcon={<AddIcon />}
            className={"rounded"}
            onClick={() => handleOpenNew(dispatch, "createOrgDepartments")}
          >
            Add
          </Button>
        </div>
      </div>

      <Table
        data={departments}
        mapData={deptMapData}
        noDataMessage="No Department Added!"
      />

      <CreateOrgDepartments />
    </PageContainer>
  );
};

export default OrgDepartments;
